<template>
  <section class="first-screen">
    <div class="first-screen__body" id="sectionScroll1">
      <div class="container">
        <div class="text">
          <h1 class="animation a-translateY">SolarBox</h1>
          <small v-if="HEADER_LANG === 'en'" class="animation a-translateY a-tr-1">We build sustainable environment</small>
          <small v-if="HEADER_LANG === 'ru'" class="animation a-translateY a-tr-1">Мы создаем благоприятную окружающую среду</small>
        </div>
        <div class="icon animation a-translateY a-tr-3">
          <svg width="29" height="68" viewBox="0 0 29 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6618 12.6026H15.4771C21.8931 12.6026 27.145 17.8546 27.145 24.2705V43.5553C27.145 49.9713 21.8931 55.2232 15.4771 55.2232H12.6618C6.24582 55.2232 0.993896 49.9713 0.993896 43.5553V24.2705C0.993896 17.8546 6.24582 12.6026 12.6618 12.6026Z" stroke="white"/>
            <path d="M17.223 55.0706H10.917C5.25673 55.0706 0.627144 50.4411 0.627144 44.7819V23.044C0.627144 17.3848 5.25787 12.7552 10.917 12.7552H17.2219C22.8822 12.7552 27.5118 17.3848 27.5118 23.044V44.7819C27.5118 50.4411 22.881 55.0706 17.2219 55.0706H17.223Z" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.1651 29.621H13.9738C13.3611 29.6195 12.7739 29.3755 12.3407 28.9422C11.9074 28.509 11.6633 27.9218 11.6618 27.3091V20.4245C11.6618 19.1535 12.7028 18.1137 13.9738 18.1137H14.1651C15.4361 18.1137 16.4771 19.1535 16.4771 20.4256V27.3114C16.4771 28.5824 15.4361 29.6233 14.1651 29.6233V29.621Z" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.0714 61.3516L14.131 67.2921" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.14267 61.3516L14.0831 67.2921" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.14267 6.54372L14.0831 0.603271" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.0714 6.54372L14.131 0.603271" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="first-screen__bg" id="first-screen__bg">
      <picture>
        <source srcset="../../public/static/images/home/1.webp">
        <img src="../../public/static/images/home/1.jpg" alt="">
      </picture>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SectionFirstScreen',
  components: {
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

//
.first-screen {
  position: relative;
  width: 100%;
  height: 90vh;
  &__body {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    .container {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      align-items: center;
    }
    h1 {
      color: $cWhite;
      text-align: center;
      margin-top: 50px;
      @media (max-width: 575.98px) {
        margin-top: 20px;
      }
    }
    small {
      color: $cWhite;
      font-size: 3rem;
      text-align: center;
      display: block;
      @media (max-width: 575.98px) {
        font-size: 2.4rem;
      }
    }
    svg {
      animation-name: mouse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      margin-bottom: 50px;
      @media (max-width: 575.98px) {
        margin-bottom: 20px;
      }
    }
  }
  &__bg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
@keyframes mouse {
  0% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(-10px);
  }
}
</style>
